<template>
    <div class="act" v-if="act">
        <template v-if="typeof act.bg == 'string'">
            <img :src="$cdnPath.img + act.bg" class="bgImg"/>
            <div v-for="(btn,index) in act.btns" :class="['btn', btn.css?btn.css:'']" :key="index" @click="doActivity(btn.goodsInfo)" :style="btn.position"></div>
        </template>
        <template v-else>
            <div v-for="(bg,ind) in act.bg" style="position:relative;" :key="ind">
                <component v-if="bg.component" :is="myComponent[bg.component]"></component>
                <template v-else>
                    <img :src="$cdnPath.img + bg.img" class="bgImg" />
                    <template v-if="bg.btns">
                        <div v-for="(btn,index) in bg.btns" :key="index"
                            :class="['btn', btn.css?btn.css:'']"
                            :data-clipboard-text="btn.copy? btn.copy:''"
                            @click="btn.goodsInfo?'':copy(btn.mes)"
                            :style="btn.position">
                        </div>
                    </template>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
    import Clipboard from 'clipboard'
    export default {
        name: "activityAll",
        data(){
            return {
                act:null,
                activityId : 0,fooId:1300,
                myComponent:{},
                cof:{
                    '93' : {
                        title: '征稿VOL1来啦！',
                        bg : [
                            {
                                img:'Activity/zgvol1/1.png',
                            }, {
                                img:'Activity/zgvol1/2.png',
                            }, {
                                img:'Activity/zgvol1/3.png',
                            }, {
                                img:'Activity/zgvol1/4.png',
                            }, {
                                img:'Activity/zgvol1/5.png',
                                btns:[
                                    {
                                        position : {top:'48%', left:'36%', width:'28%', height:'15%'},
                                        css:'to-copy',
                                        copy:'3492460757',
                                        mes:'QQ号已复制，快去添加吧！'
                                    }
                                ]
                            }, {
                                img:'Activity/zgvol1/6.png',
                            }, {
                                img:'Activity/zgvol1/7.png',
                            },{
                                img:'Activity/zgvol1/8.png',
                            },
                        ],
                    },
                    '123': {
                        component:['act123'],
                        title:'有影APP，好电影与世界分享',
                        bg :[
                            {component:'act123'}
                        ]
                    },
                    '134': {
                        component:['act134'],
                        title:'有影APP，好电影与世界分享',
                        bg :[
                            {component:'act134'}
                        ]
                    },
                    '135': {
                        component:['act135'],
                        title:'有影APP，好电影与世界分享',
                        bg :[
                            {component:'act135'}
                        ]
                    },
                    '136': {
                        component:['act136'],
                        title:'有影APP，好电影与世界分享',
                        bg :[
                            {component:'act136'}
                        ]
                    },
                    '391': {
                        component:['act391'],
                        title:'全新图解，感恩有你！',
                        bg :[
                            {component:'act391'}
                        ]
                    },
                    '466': {
                        component:['act466'],
                        title:'快来帮帮我',
                        bg :[
                            {img: 'Activity/466/bg.jpg'},
                            {component:'act466'}
                        ]
                    }
                }
            };
        },
        computed:{
        },
        created(){
            if (!this.$route.params.id || !this.cof[this.$route.params.id]) {
                this.$dialog.alert({mes:'活动不存在，或者已经下架',callback:()=>{this.$yymd.close();}}); return;
            }
            this.act = this.cof[this.$route.params.id];
            if (this.act.component) {
                for (let a=0; a<this.act.component.length; a++) {
                    this.$set(this.myComponent,this.act.component[a], () => import(`./normalAll/components/${this.act.component[a]}`));
                }
            }
            document.title = this.act.title;
            this.activityId = this.$route.params.id;
            this.$SPM(this.fooId, this.activityId);
        },
        methods :{
            copy(mes) {
                var clipboard = new Clipboard('.to-copy')
                clipboard.on('success', e => {
                    clipboard.destroy()
                    this.$dialog.alert({ mes: mes})
                    // 释放内存
                })
                clipboard.on('error', e => {
                    // 不支持复制
                    console.log('该浏览器不支持自动复制', e)
                    // 释放内存
                    clipboard.destroy()
                })
            },
        }
    }
</script>

<style>

</style>
<style scoped>
    .act {position: relative; margin:0 auto; min-width:320px; max-width:750px;line-height: 0;}
    .bgImg {
        width:100%;height:auto;
    }
    .btn {position:absolute; background-size:100% 100%; background-position: center; background-repeat: no-repeat;}
    .big {
        animation: big 1s .2s ease infinite;
    }
    @-webkit-keyframes big {
        0%,100% {transform: scale(1);}
        50% {transform: scale(1.1);}
    }
    .tada {
        animation: tada 1s .2s ease infinite;
    }
    @-webkit-keyframes tada{
        0%,10% {}
        20% { transform:rotate(-3deg);}
        30%,50%,70%,90% { transform:rotate(3deg);}
        40%,60%,80% { transform:rotate(-3deg);}
        100% { transform:rotate(0);}
    }
</style>

<style rel="stylesheet/less" lang="less" scoped>
    .pay-container {
        line-height: 1.2em;
        background-color:#fff;
        border-radius: .1rem;
        &__header {
            height:1rem;position: relative;
            &-title {
                text-align: center;line-height: 1rem;font-size:.34rem;
            }
            &-close {
                position: absolute; right:.3rem;top:.3rem;
            }
        }
        &__header:after {
            content: "";position: absolute;z-index: 0;bottom: 0;left: 0;width: 100%;
            border-bottom: 1px solid #eee;
            transform: scaleY(.5);
            transform-origin: 0 0;
        }

        &__body {
            padding:.3rem 0;
            &-goods-info {
                text-align: center; line-height: .6rem;
            }
            &-price {
                text-align: center; line-height: 1.2rem; font-size:.6rem; font-weight: 800;
            }

            &-pay-list {
                padding: 0 .4rem;
                &-txt {
                    padding:.2rem;
                }
            }

            &-btn {
                padding:0 .4rem .2rem .4rem;
            }
        }
    }
</style>